<template>
  <div>
    <b-modal
      size="xl"
      centered
      hide-footer
      title="Excluindo Notificação"
      header-bg-variant="orange"
      header-text-variant="light"
      v-model="open"
    >
      <b-container>
        <b-row class="mt-4">
          <b-col cols="12" align-self="center">
            <h3 class="text-center">Deseja realmente excluir a notificação?</h3>
          </b-col>
          <b-col cols="12" class="d-flex justify-content-end mt-4">
            <b-button 
              variant="warning"
              @click="closeModal()"
            >
            <i class="fas fa-ban mr-2"></i>
              Cancelar
            </b-button>

            <b-button 
              variant="danger"
              class="ml-4"
              @click="deleteNotification()"
            >
            <i class="fas fa-trash mr-2"></i>
              Excluir Notificação
            </b-button>

          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
export default {
  emits: ['delete'],
  data() {
    return {
      open: false,
      id: null,
    }
  },

  methods: {
    toggleOpen(id = null) {
      this.open = !this.open;
      console.log(id)
      this.id = id;
    },
    closeModal() {
      this.open = false;
    },
    deleteNotification() {
      this.$emit('delete', this.id);
      this.closeModal();
    },
    
  }
}
</script>
